import { render, staticRenderFns } from "./ForumAttend.vue?vue&type=template&id=3a9f84dc&scoped=true&"
import script from "./ForumAttend.vue?vue&type=script&lang=js&"
export * from "./ForumAttend.vue?vue&type=script&lang=js&"
import style0 from "./ForumAttend.vue?vue&type=style&index=0&id=3a9f84dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9f84dc",
  null
  
)

export default component.exports